export const MEDIA_FILTERING_QUERY_PARAMETER = 'filters';
export const MEDIA_FILTERING_QUERY_FILTER_GROUP_SEPARATOR = ',';
export const MEDIA_FILTERING_QUERY_FILTER_KEY_SEPARATOR = '::';
export const MEDIA_FILTERING_QUERY_FILTER_VALUES_SEPARATOR = ';;';
export const MEDIA_PAGING_QUERY_PARAMETER = 'page';
